function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.00024 1.57924L17.0001 15.3291",
  stroke: "#494B4E",
  strokeWidth: 3,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 1.57959L2.14919 15.2714",
  stroke: "#494B4E",
  strokeWidth: 3,
  strokeLinecap: "round"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 19,
  height: 17,
  viewBox: "0 0 19 17",
  fill: "none"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/x.d54fea31.svg";
export { SvgComponent as ReactComponent };